import React from 'react';

type IconProps = {
    width?: number;
    height?: number;
    color?: string;
};

const IconDownload: React.FC<IconProps> = ({ width = 28, height = 28, color = 'white' }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 28 22"
            fill="none"
        >
            <path
                d="M22.972 8.288C22.608 3.657 18.723 0 14 0C9.96 0 6.492 2.624 5.373 6.451C2.181 7.559 0 10.583 0 14C0 18.411 3.589 22 8 22H21C24.86 22 28 18.86 28 15C28 11.851 25.93 9.148 22.972 8.288ZM18.707 13.707L14.707 17.707C14.512 17.902 14.256 18 14 18C13.744 18 13.488 17.902 13.293 17.707L9.293 13.707C9.007 13.421 8.921 12.991 9.076 12.617C9.231 12.244 9.596 12 10 12H12V8C12 6.896 12.896 6 14 6C15.104 6 16 6.896 16 8V12H18C18.404 12 18.769 12.244 18.924 12.617C19.079 12.991 18.993 13.421 18.707 13.707Z"
                fill={color}
            />
        </svg>
    );
};

export default IconDownload;
